import React, { useState } from "react";
import styles from "./ExperiencesPage.module.css";
import { activitySections, experienceSections } from "./experiencesData";
import HeroSection from "../HomePage/sections/HeroSection";

const experienceSlides = [
  { id: "coast", image: "/images/Tweed Heads.png", text: "NEARBY THINGS TO DO" },
  { id: "beach", image: "/images/Duranbah Beach.png", text: "BEACHES ALONG THE TWEED COAST" },
  { id: "lookout", image: "/images/Kirra Hill Lookout.png", text: "COASTAL WALKS AND LOOKOUTS" },
  { id: "sunset", image: "/images/GoldCoast.png", text: "DAY TRIPS TOWARDS THE GOLD COAST" },
  { id: "aerial", image: "/images/Queensland.png", text: "EXPLORE TWEED HEADS SOUTH, NSW" },
];

const fallbackImage = "/images/ARB. 7.jpg";

const PlaceCard = ({ place }) => (
  <article className={styles.card} id={place.id}>
    <img
      src={place.image}
      alt={place.name}
      onError={(event) => {
        event.currentTarget.src = fallbackImage;
      }}
    />
    <div className={styles.cardBody}>
      <h3>{place.name}</h3>
      <p className={styles.type}>{place.type}</p>
      <p>{place.description}</p>
      <p className={styles.address}>Address: {place.address}</p>
      <a href={place.mapsHref} target="_blank" rel="noopener noreferrer">
        {place.mapsLabel} →
      </a>
    </div>
  </article>
);

const SectionBlock = ({ section }) => (
  <section className={styles.section} id={section.id}>
    <h2>{section.title}</h2>
    <div className={styles.grid}>
      {section.places.map((place) => (
        <PlaceCard key={place.id} place={place} />
      ))}
    </div>
  </section>
);

const ExperiencesPage = () => {
  const groups = [...experienceSections, ...activitySections];
  const [activeId, setActiveId] = useState("all");
  const visible = activeId === "all" ? groups : groups.filter((section) => section.id === activeId);

  return (
    <div className={styles.page}>
      <HeroSection slides={experienceSlides} />
      <header className={styles.hero}>
        <p className={styles.kicker}>Things to do</p>
        <h1>Nearby Things To Do</h1>
        <div className={styles.filters} role="tablist" aria-label="Nearby things to do">
          <button
            type="button"
            className={activeId === "all" ? styles.filterActive : styles.filter}
            onClick={() => setActiveId("all")}
          >
            All
          </button>
          {groups.map((section) => (
            <button
              key={section.id}
              type="button"
              className={activeId === section.id ? styles.filterActive : styles.filter}
              onClick={() => setActiveId(section.id)}
            >
              {section.title}
            </button>
          ))}
        </div>
      </header>

      {visible.map((section) => (
        <SectionBlock key={section.id} section={section} />
      ))}
    </div>
  );
};

export default ExperiencesPage;
